export const normalizeBrand = (brand: string): string => {
  const brandLowerCase = brand?.trim()?.toLowerCase()
  
  // for backwards compatibility with CLE
  if (brandLowerCase === 'clearly') {
    return 'cle'
  }
  
  return brandLowerCase
}